var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 1.27261C11.9997 1.34424 11.9856 1.41519 11.9582 1.48137C11.9308 1.54754 11.8905 1.60765 11.8398 1.65823L6.38546 7.11259C6.33484 7.16327 6.27472 7.20348 6.20856 7.23091C6.14239 7.25834 6.07146 7.27246 5.99983 7.27246C5.9282 7.27246 5.85728 7.25834 5.79111 7.23091C5.72494 7.20348 5.66483 7.16327 5.61421 7.11259L0.159847 1.65823C-0.0532825 1.4451 -0.0532826 1.09998 0.159847 0.886986C0.372976 0.673993 0.7181 0.673857 0.931093 0.886986L5.99983 5.95572L11.0686 0.886985C11.1192 0.836306 11.1793 0.796101 11.2455 0.76867C11.3116 0.741239 11.3826 0.72712 11.4542 0.72712C11.5258 0.72712 11.5967 0.741239 11.6629 0.76867C11.7291 0.796101 11.7892 0.836306 11.8398 0.886985C11.8905 0.937568 11.9308 0.997676 11.9582 1.06385C11.9856 1.13003 11.9997 1.20097 11.9996 1.27261Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropArrowWhite);
export default __webpack_public_path__ + "static/media/drop-arrow-white.418688d4b2c30078d27b0e715682adc1.svg";
export { ForwardRef as ReactComponent };